import { useQuery } from 'react-query';

import { getContract as queryFn } from 'api/endPoints/getContract';

export const useQueryGetTagList = ({ contractId }) => {
    return useQuery(['useQueryGetTagList', contractId], () => queryFn(contractId), {
        enabled: Boolean(contractId),
    });
};
